import { webAppUserGet } from "@tradingApp/helpers/webApp/userGet";

export function isPmUser(): boolean {
  const user = webAppUserGet();

  if (!user || !user.username) {
    return false;
  }

  return "Kwlad1ck" === user.username;
}
